var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "29px",
    viewBox: "0 0 24 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B3A35B6-99BA-4E6F-A22A-49051BC4F165") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dealer-Support-Dashboard",
    transform: "translate(-28.000000, -341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-main",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidenav/menu",
    transform: "translate(0.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(16.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_48/dummy-icon_48/warranty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0159,21.7314 C27.1959,21.8584 27.3129,22.0494 27.3499,22.2664 C27.3859,22.4824 27.3349,22.7014 27.2079,22.8804 L24.2449,27.0314 C24.1029,27.2284 23.8819,27.3534 23.6419,27.3734 L23.5739,27.3764 C23.3569,27.3764 23.1439,27.2884 22.9899,27.1344 L20.6559,24.8004 C20.5009,24.6444 20.4139,24.4374 20.4139,24.2174 C20.4149,23.9974 20.5009,23.7904 20.6579,23.6344 C20.8119,23.4794 21.0179,23.3944 21.2389,23.3944 C21.4589,23.3944 21.6639,23.4794 21.8209,23.6354 L23.4669,25.2814 L25.8679,21.9224 C26.0219,21.7074 26.2719,21.5774 26.5379,21.5774 C26.7109,21.5774 26.8749,21.6304 27.0159,21.7314 Z M34.3284,16.4917 C30.9374,15.8077 28.8104,14.3447 28.3164,12.3527 L27.9224,12.2327 C26.6444,11.8457 25.3264,11.6487 24.0004,11.6487 C22.6754,11.6487 21.3544,11.8457 20.0784,12.2327 L19.6824,12.3527 C19.1894,14.3447 17.0624,15.8077 13.6714,16.4917 L13.9654,25.6457 C13.9664,32.7747 22.1634,36.4507 24.0004,37.1847 C25.8374,36.4507 34.0334,32.7757 34.0334,25.6717 L34.3284,16.4917 Z M35.3064,14.9947 C35.7144,15.0597 36.0124,15.4207 35.9994,15.8347 L35.6824,25.6987 C35.6834,34.7277 24.7394,38.6797 24.2734,38.8447 C24.1864,38.8757 24.0944,38.8907 24.0004,38.8907 C23.9074,38.8907 23.8154,38.8757 23.7264,38.8457 C23.2604,38.6807 12.3164,34.7227 12.3164,25.6727 L12.0004,15.8347 C11.9874,15.4207 12.2854,15.0597 12.6944,14.9947 C13.9194,14.7977 17.9334,13.9727 18.1364,11.6407 C18.1654,11.3047 18.3924,11.0237 18.7164,10.9247 L19.5994,10.6567 C21.0314,10.2207 22.5134,9.9997 24.0004,9.9997 C25.4874,9.9997 26.9694,10.2207 28.4014,10.6567 L29.2844,10.9247 C29.6074,11.0227 29.8344,11.3047 29.8644,11.6417 C30.0654,13.9727 34.0814,14.7977 35.3064,14.9947 Z M24.0003,28.8335 C26.4883,28.8335 28.5133,26.8095 28.5133,24.3195 C28.5133,21.8315 26.4883,19.8075 24.0003,19.8075 C21.5113,19.8075 19.4863,21.8315 19.4863,24.3195 C19.4863,26.8095 21.5113,28.8335 24.0003,28.8335 Z M24.0003,18.1595 C27.3973,18.1595 30.1613,20.9225 30.1613,24.3195 C30.1613,27.7175 27.3973,30.4805 24.0003,30.4805 C20.6033,30.4805 17.8383,27.7175 17.8383,24.3195 C17.8383,20.9225 20.6033,18.1595 24.0003,18.1595 Z",
    id: "Combined-Shape",
    fill: "#3F3F3F"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.9fb0d584e05078d569670b6526123c3e.svg";
export { ForwardRef as ReactComponent };